import React from 'react';
import { XrinvData } from '../../types/comms-check';

export const InventoryDataSection = ({ data }: { data: XrinvData[] }) => {
  return (
    <>
      {data.map(({ deviceId, deviceType, deviceStatus, lastCommunicatedTime }) => (
        <div key={deviceId} className={'informationSection'} data-testid={`info-section-device-${deviceType}`}>
          <div className={'informationSectionText'}>{deviceType}:</div>
          <div className={'informationRow'}>
            <div className={'informationSectionText'}>{`Status: ${deviceStatus}`}</div>
            <div className={'informationSectionText'}>{`GUID: ${deviceId}`}</div>
            {lastCommunicatedTime && <div className={'informationSectionText'}>{`LCT: ${lastCommunicatedTime}`}</div>}
          </div>
        </div>
      ))}
    </>
  );
};
